<div class=" mwp-modal ">
    <div class="header d-flex justify-content-center">
        <mwp-text-translate text="Inactivity Alert" jsonKey="timeoutDialog1" />
    </div>
    <div class="body">
        <div class="message-container">
            <div class="mb-2 d-flex justify-content-center">
                <mwp-text-translate text="You will be automatically logged out in:" jsonKey="timeoutDialog3" />
                <span class="ms-1">{{minutes}}:{{ formatNumber(seconds) }}</span>
            </div>
        </div>
        <div class="footer d-inline-flex justify-content-center w-100">
            <button class="mwp-button" (click)="buttonClicked()">
                <mwp-text-translate text="Stay Logged in" jsonKey="timeoutDialog3" />
            </button>
        </div>
    </div>